/**
 * Chelsea's canonical social / channel links — single source of truth.
 *
 * Sourced from the legacy site (afewloosethreads.com / CBP). Reference these
 * everywhere (footer, connect section, "see more" CTAs) instead of hardcoding
 * URLs so handle changes happen in one place.
 */

export type SocialKey = "instagram" | "tiktok" | "youtube" | "facebook";

export type SocialChannel = {
  key: SocialKey;
  platform: string;
  /** display handle */
  handle: string;
  url: string;
};

export const SOCIALS: Record<SocialKey, SocialChannel> = {
  instagram: {
    key: "instagram",
    platform: "Instagram",
    handle: "@chelsea_b_porter",
    url: "https://www.instagram.com/chelsea_b_porter",
  },
  tiktok: {
    key: "tiktok",
    platform: "TikTok",
    handle: "@chelsea_b_porter",
    url: "https://www.tiktok.com/@chelsea_b_porter",
  },
  youtube: {
    key: "youtube",
    platform: "YouTube",
    handle: "@afewloosethreads",
    url: "https://www.youtube.com/@afewloosethreads",
  },
  facebook: {
    key: "facebook",
    platform: "Facebook",
    handle: "@afewloosethreads",
    url: "https://www.facebook.com/afewloosethreads",
  },
};

/** Order used for follow rows / icon lists. */
export const SOCIAL_ORDER: SocialKey[] = [
  "instagram",
  "tiktok",
  "youtube",
  "facebook",
];
